import { getConfig as _getConfig } from '@b2ag/micro-front-tools'

export function getConfig() {
  return {
    productApiHost: _getConfig('PRODUCT_API_HOST'),
    mediaApiHost: _getConfig('MEDIA_API_HOST'),
    idfTrackingApiHost: _getConfig('IDF_TRACKING_API_HOST'),
  }
}
